module.exports = __webpack_public_path__ + "ca8e5e185294bb0791e8eb79e2544f09.png";